export const ANTHROPIC_FUNCTION_PATH='/.netlify/functions/anthropic-proxy';

// The Netlify function only exists on Netlify deployments. Locally (Vite dev
// server, StackBlitz, etc.) the path is served by the SPA fallback instead.
export const canUseNetlifyFunction=()=> {
  if (typeof window==='undefined') return false;
  const host=window.location.hostname;
  return !(
    host==='localhost' ||
    host==='127.0.0.1' ||
    host.endsWith('.webcontainer.io') ||
    host.endsWith('.stackblitz.io')
  );
};

let availability=null;

/**
 * Check once per page load whether the anthropic-proxy function is really
 * deployed, using its /health endpoint. Drag-and-drop deploys and failed
 * builds have no functions: Netlify answers 404 (or the SPA's index.html),
 * and we must call Anthropic directly instead of treating every request
 * as "model not found".
 */
export const isAnthropicFunctionAvailable=()=> {
  if (!canUseNetlifyFunction()) return Promise.resolve(false);
  if (!availability) {
    availability=fetch(`${ANTHROPIC_FUNCTION_PATH}/health`,{
      headers: {accept: 'application/json'},
      signal: AbortSignal.timeout(5000),
    })
      .then(async (response)=> {
        if (!response.ok) return false;
        if (!(response.headers.get('content-type') || '').includes('application/json')) return false;
        const body=await response.json().catch(()=> null);
        return body?.service==='anthropic-proxy';
      })
      .catch(()=> false);
  }
  return availability;
};
